// StoryLoaderStartButton — extrahiert aus
// app/src/components/editor/Viewer/StartScreen/StoryLoaderStartButton.tsx
// (Plan A Mapping-Audit 2026-05-22).
//
// Abstrahiert app/-Coupling:
//   - `viewerFont` ("SofiaSansSemiCondensed") inline-kopiert
//   - `loadingGif`-Asset durch CSS-Spinner ersetzt (kein Asset-Bundle nötig)
//   - `OptimizedCloudinaryImage` durch native <img> ersetzt
//   - `SIZES` aus packages/viewer/constants

import type { ImageAssetBackend } from "@scrolly/post-types";
import type { MouseEventHandler } from "react";
import { SIZES } from "./constants";

const VIEWER_FONT_FALLBACK = "SofiaSansSemiCondensed";

function ProgressLoader({ progress }: { progress: number }) {
  return (
    <>
      <style>{`@keyframes scrollyViewerSpin { to { transform: rotate(360deg); } }`}</style>
      <div
        className="flex flex-col items-center text-white"
        style={{
          fontSize: "21px",
          fontWeight: "bold",
          pointerEvents: "none",
        }}
      >
        <div
          style={{
            width: 60,
            height: 60,
            border: "4px solid rgba(255,255,255,0.2)",
            borderTopColor: "white",
            borderRadius: "50%",
            animation: "scrollyViewerSpin 1s linear infinite",
            marginBottom: 12,
          }}
        />
        <p
          style={{ textAlign: "center", transform: "translateY(-5px)" }}
        >{`${Math.round(progress * 100)}%`}</p>
      </div>
    </>
  );
}

function Button({
  asset,
  onClick,
}: {
  asset?: ImageAssetBackend;
  onClick: MouseEventHandler<HTMLButtonElement>;
}) {
  return asset ? (
    <button
      className="cursor-pointer border-none bg-transparent"
      style={{ width: `${SIZES.storyHeroStartButtonWidth}px` }}
      onClick={onClick}
    >
      <img
        style={{
          width: "100%",
          height: "auto",
          objectFit: "cover",
        }}
        width={asset.width}
        height={asset.height}
        sizes={`${SIZES.storyHeroStartButtonWidth}px`}
        src={asset.ppiUrl || asset.url}
        alt="Start the story"
      />
    </button>
  ) : (
    <button
      className="cursor-pointer border border-white bg-transparent text-white"
      style={{
        font: `bold 18px ${VIEWER_FONT_FALLBACK}`,
        textTransform: "uppercase",
        borderRadius: "100px",
        padding: "10px 20px",
      }}
      onClick={onClick}
    >
      Start
    </button>
  );
}

interface Props {
  progress: number;
  asset?: ImageAssetBackend;
  onClick: MouseEventHandler<HTMLButtonElement>;
}

export function StoryLoaderStartButton({
  progress,
  onClick,
  asset,
}: Props) {
  return (
    <div className="flex flex-col flex-nowrap items-center justify-center">
      {progress < 1 && <ProgressLoader progress={progress} />}
      {progress >= 1 && <Button onClick={onClick} asset={asset} />}
    </div>
  );
}

export default StoryLoaderStartButton;
